// A normal Google Drive "share link" (e.g. from Get Link) points at Drive's
// viewer page, not the raw image bytes, so it won't work directly as an
// <img src>. This rewrites the common share-link shapes into Drive's direct
// content URL. Anything that isn't a recognized Drive share link (a plain
// image URL from anywhere else) passes through unchanged. Shared by any page
// that lets someone paste in a photo link (Staff, Gallery, ...).
export function resolveImageUrl(url) {
    const trimmed = (url || '').trim();
    if (!trimmed) return trimmed;

    const fileMatch = /drive\.google\.com\/file\/d\/([^/]+)/.exec(trimmed);
    if (fileMatch) return `https://drive.google.com/uc?export=view&id=${fileMatch[1]}`;

    const openMatch = /drive\.google\.com\/open\?id=([^&]+)/.exec(trimmed);
    if (openMatch) return `https://drive.google.com/uc?export=view&id=${openMatch[1]}`;

    return trimmed;
}
